<template>
  <v-btn icon @click="handleClick">
    <span v-html="svg"></span>
  </v-btn>
</template>

<script>
import { defineComponent, computed } from "vue";

export default defineComponent({
  props:{
    editMode: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context){
    const handleClick = ()=>{
      context.emit('update:editMode', !props.editMode)
    }

    const svg = computed(()=>{
      if(props.editMode){
         return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-v-28a30187="" data-icon="mdi-pencil" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83l3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25z" fill="currentColor"></path></svg>';
        } else {
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-v-28a30187="" data-icon="mdi-pencil-off" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M18.66 2c-.26 0-.5.09-.69.28l-1.84 1.85l3.75 3.75l1.84-1.85c.39-.39.39-1.03 0-1.4l-2.34-2.35c-.2-.19-.47-.28-.72-.28M3.28 4L2 5.28l6.5 6.47l-4.5 4.5V20h3.75l4.5-4.5l6.47 6.5L20 20.72l-6.5-6.47l-3.75-3.75L3.28 4m11.78 1.19l-4.03 4.03l3.75 3.75l4.03-4.03l-3.75-3.75z" fill="currentColor"></path></svg>';
        }
      }
    ) 

    return {
      svg,
      handleClick
    }
  }
})
</script>
